export default __webpack_public_path__ + "static/product_sans_bold-webfont-a522f3fedfe54179c63a29a989c7fcd2.woff2";